<template>
  <div>
    <form @submit.prevent="registerAttempt">
    <div class="form-group" :class="{ error: $v.claimForm.username.$error }">
      <h4>{{ $t('placeholder.username') }}</h4>
      <input
        :placeholder="$t('placeholder.username')"
        class="form-control"
        :disabled="loading || (finishingUserData && finishingUserData.username)"
        type="text"
        v-model.lazy="claimForm.username"
        @blur="$v.claimForm.username.$touch"
        autocomplete="username"
      />
      <template v-if="$v.claimForm.username.$error">
        <p class="error-message" v-if="!$v.claimForm.username.required">
          {{ $t("validations.required", { field: $t("fields.username") }) }}
        </p>
      </template>
    </div>
    <div class="form-group" :class="{ error: $v.claimForm.email.$error }">
      <h4>{{ $t('placeholder.email') }}</h4>
      <input
        :placeholder="$t('placeholder.email')"
        class="form-control"
        :disabled="loading || (finishingUserData && finishingUserData.email)"
        type="email"
        v-model.lazy="claimForm.email"
        @blur="$v.claimForm.email.$touch"
        autocomplete="username"
      />
      <template v-if="$v.claimForm.email.$error">
        <p class="error-message" v-if="!$v.claimForm.email.required">
          {{ $t("validations.required", { field: $t("fields.email") }) }}
        </p>
        <p class="error-message" v-if="!$v.claimForm.email.email">
          {{ $t("validations.email", { field: $t("fields.email") }) }}
        </p>
      </template>
    </div>

    <!-- COUNTRY -->
    <div class="form-group" :class="{ error: $v.claimForm.country.$error }">
      <h4>{{ $t('fields.country') }}</h4>
      <input
        :placeholder="$t('fields.country')"
        class="form-control"
        :disabled="loading || (finishingUserData && finishingUserData.country)"
        type="text"
        v-model.lazy="claimForm.country"
        @blur="$v.claimForm.country.$touch"
        autocomplete="country"
      />
      <template v-if="$v.claimForm.country.$error">
        <p class="error-message" v-if="!$v.claimForm.country.required">
          {{ $t("validations.required", { field: $t("fields.country") }) }}
        </p>
      </template>
    </div>
    <!-- COUNTRY -->

    <!-- DOCUMENT -->
    <div class="form-group" :class="{ error: $v.claimForm.document.$error }">
      <h4>{{ $t('fields.document') }}</h4>
      <input
        :placeholder="$t('fields.document')"
        class="form-control"
        :disabled="loading || (finishingUserData && finishingUserData.document)"
        type="text"
        v-model.lazy="claimForm.document"
        @blur="$v.claimForm.document.$touch"
        autocomplete="document"
      />
      <template v-if="$v.claimForm.document.$error">
        <p class="error-message" v-if="!$v.claimForm.document.required">
          {{ $t("validations.required", { field: $t("fields.document") }) }}
        </p>
      </template>
    </div>
    <!-- DOCUMENT -->

    <!-- CARD COMPANY -->
    <div
      class="form-group"
      :class="{ error: $v.claimForm.card_company.$error }"
    >
      <h4>{{ $t('fields.card_company') }}</h4>
      <input
        :placeholder="$t('fields.card_company')"
        class="form-control"
        :disabled="
          loading || (finishingUserData && finishingUserData.card_company)
        "
        type="text"
        v-model.lazy="claimForm.card_company"
        @blur="$v.claimForm.card_company.$touch"
        autocomplete="card_company"
      />
      <template v-if="$v.claimForm.card_company.$error">
        <p class="error-message" v-if="!$v.claimForm.card_company.required">
          {{ $t("validations.required", { field: $t("fields.card_company") }) }}
        </p>
      </template>
    </div>
    <!-- CARD COMPANY -->

    <!-- CARD NUMBER -->
    <div
      class="form-group"
      :class="{ error: $v.claimForm.card_number.$error }"
    >
      <h4>{{ $t('fields.card_last_four_digits') }}</h4>
      <input
        :placeholder="$t('fields.card_last_four_digits')"
        class="form-control"
        :disabled="
          loading || (finishingUserData && finishingUserData.card_number)
        "
        type="text"
        v-model.lazy="claimForm.card_number"
        @blur="$v.claimForm.card_number.$touch"
        autocomplete="card_number"
      />
      <template v-if="$v.claimForm.card_number.$error">
        <p class="error-message" v-if="!$v.claimForm.card_number.required">
          {{ $t("validations.required", { field: $t("fields.card_last_four_digits") }) }}
        </p>
        <p class="error-message" v-if="$v.claimForm.card_number.required && !$v.claimForm.card_number.helpers">
          {{ $t("validations.card_number", { field: $t("fields.card_last_four_digits") }) }}
        </p>
      </template>
    </div>
    <!-- CARD NUMBER -->

    <!-- CLAIM -->
    <div
      class="form-group"
      :class="{ error: $v.claimForm.claim.$error }"
    >
      <h4>{{ $t('fields.claim') }}</h4>
      <textarea
        :placeholder="$t('fields.claim')"
        class="form-control"
        :disabled="
          loading || (finishingUserData && finishingUserData.claim)
        "
        type="text"
        v-model.lazy="claimForm.claim"
        @blur="$v.claimForm.claim.$touch"
        autocomplete="claim"
      />
      <template v-if="$v.claimForm.claim.$error">
        <p class="error-message" v-if="!$v.claimForm.claim.required">
          {{ $t("validations.required", { field: $t("fields.claim") }) }}
        </p>
      </template>
    </div>
    <!-- CLAIM -->

    <!-- ATTACHED FILES -->
    <div class="form-group" v-if="attachmentsEnabled" >
      <h4>{{ $t('fields.attached_files') }}</h4>
      <input
        :placeholder="$t('fields.attached_files')"
        class="form-control"
        :disabled="
          loading || (finishingUserData && finishingUserData.attached_files)
        "
        type="file"
        name="files"
        multiple
        autocomplete="attached_files"
        ref="files"
      />
    </div>
    <!-- ATTACHED FILES -->

    <div
      class="captcha-container"
      :sitekey="recaptchaPublicKey"
      v-if="recaptchaPublicKey"
    >
      <vue-recaptcha
        ref="recaptcha"
        :sitekey="recaptchaPublicKey"
        :loadRecaptchaScript="true"
        :theme="'light'"
        @verify="claimForm.recaptcha = $event"
        @expire="claimForm.recaptcha = null"
      />
      <template v-if="$v.claimForm.recaptcha.$error">
        <p class="error-message" v-if="!$v.claimForm.recaptcha.required">
          {{ $t("validations.captcha") }}
        </p>
      </template>
    </div>

    <div class="messages">
      <div v-for="(errors, errorKey) in claimErrors" :key="errorKey">
        <p v-for="error in errors" :key="error">
          {{ error }}
        </p>
      </div>
    </div>

    <div class="buttons">
      <button class="btn-register" @click="cancelHandler">
        {{ $t("go_back") }}
      </button>
      <button class="btn-register" v-if="!loading" type="submit">
        {{ $t("labels.send") }}
      </button>
      <Spinner v-else />
    </div>
    </form>

    <div class="modal" v-if="showModal">
      <FullBackdrop class="fenif-test">
        <div class="container">
          <h3 class="modal-title" style="color:red;">{{$t('report.title')}}</h3>

          <Spinner v-if="loading"/>

          <template v-else>
            <h4>{{ endedRequestMessage }}</h4>
            <div class="footer">
              <button class="cancel active" @click="hideModal()">
                {{ $t("dashboard.back") }}
              </button>
            </div>
          </template>
        </div>
      </FullBackdrop>
    </div>
  </div>
</template>

<script>
import Spinner from "../Spinner";
import FullBackdrop from "./../FullBackdrop";

import { required, email, requiredIf } from "vuelidate/lib/validators";
import resources from "../../resources";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    Spinner,
    VueRecaptcha,
    FullBackdrop
  },
  props: {
    finishingUserData: {
      required: false,
      default() {
        return null;
      },
    },
    
  },
  data() {
    return {
      claimForm: {
        email: "",
        username: "",
        country: "",
        document: "",
        card_company: "",
        card_number: "", //ultimos 4 digitos de la tarjeta
        claim: "",
        model_id: "",
        recaptcha: null,
        finish_token: null,
      },
      loading: false,
      keepOnView: true,
      showModal: false,
      claimErrors: {},
      endedRequestMessage: this.$t("report.response_message.waiting"),
      endedRequestTimer: null,
    };
  },
  mounted() {
    //si viene el model id por parametro, lo cargamos en el form (sino, va nulo)
    if (this.$route.params.modelId) {
      const modelId = this.$route.params.modelId;
      this.claimForm.model_id = modelId;
    }
  },
  methods: {
    registerAttempt() {
      if (this.$v.claimForm.$invalid) {
        return this.$v.claimForm.$touch();
      }

      this.loading = true;
      this.showModal = true;

      //si no está habilitado el envio de archivos, seteamos no enviamos archivos (null)
      let filesToSend = null;
      if (this.attachmentsEnabled) {
        filesToSend = this.$refs.files ? this.$refs.files.files : null;
      }

      resources.claim.generalClaim(this.claimForm, filesToSend).then(({ data }) => {
        switch (data.status) {
            case 201:
              this.endedRequestMessage = this.$t(
                "report.response_message.success"
              );
              this.keepOnView = false;
              break;

            case 422:
              this.endedRequestMessage = this.$t(
                "report.response_message.bad_request"
              );
              break;

            case 500:
              this.endedRequestMessage = this.$t("report.response_message.error");
              break;

            default:
              this.endedRequestMessage = this.$t("report.response_message.error");
              break;
          }
      }).catch((error) => {
        console.log(error);
        this.endedRequestMessage = this.$t("report.response_message.error");
        this.claimErrors = error.data.errors || {
          general: [this.$t("error")],
        };
        this.$emit("failed", error);
      }).finally(() => {
        this.loading = false;
        this.endedRequestTimer = setTimeout(() => {
          this.hideModal();
        }, 5000);
      });
    },
    hideModal() {
      if (!this.keepOnView) {
        this.$emit("successfull");
        return;
      }

      this.showModal = false;
    },
    cancelHandler() {
      this.$emit("cancel");
    },
  },
  computed: {
    recaptchaPublicKey() {
      return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
    },
    attachmentsEnabled(){
      return !! (process.env.VUE_APP_ATTACHMENTS_ENABLED && process.env.VUE_APP_ATTACHMENTS_ENABLED === 'true');
    }
  },
  validations() {
    return {
      claimForm: {
        email: {
          required,
          email,
        },
        username: {
          required,
        },
        country: {
          required,
        },
        document: {
          required,
        },
        card_company: {
          required,
        },
        card_number: {
          required,
          // helpers: (value) => {
          //   const regex = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
          //   const card_parsed = value.replace(/( |-|\.|,)/g, "");
          //   return regex.test(card_parsed);
          // }
        },
        card_company: {
          required,
        },
        claim: {
          required,
        },
        recaptcha: {
          required: requiredIf(() => this.recaptchaPublicKey),
        },
      },
    };
  },
  watch: {
    loading() {
      this.$emit("loadingChange", this.loading);
    },
    finishingUserData: {
      handler(finishingUserData) {
        if (finishingUserData) {
          Object.keys(finishingUserData).forEach((key) => {
            if (finishingUserData.hasOwnProperty(key)) {
              this.$set(this.claimForm, key, finishingUserData[key]);
            }
          });
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.endedRequestTimer);
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/classes";
@import "../../styles/variables";

.buttons {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
}

.btn-register {
  @extend %fresh-btn;
  display: block;
  width: 40%;
  border-radius: 5px;
  padding: 0.5em;
}

form h4 {
  margin: unset;
}

.modal {
  position: absolute;
  & .picture {
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ffffff;
    border-radius: 50%;
    border: 3px solid var(--pallete_main_color);
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button,
      .action {
        color: inherit;
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;

        &:hover {
          color: var(--pallete_over_main_text_color);
        }
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        @extend %fresh-btn;

        border-radius: 0.5rem;
      }
    }
  }
}

textarea.form-control {
  resize: vertical;
  max-height: 108px;
  min-height: 54px;
}
</style>
